const Mulish_400Regular = {fontFamily: 'IranSans-Regular'};
const Mulish_500Medium = {fontFamily: 'IranSans-Medium'};
const Mulish_600SemiBold = {fontFamily: 'IranSans-SemiBold'};
const Mulish_700Bold = {fontFamily: 'IranSans-Bold'};
const Mulish_800ExtraBold = {fontFamily: 'IranSans-ExtraBold'};
const Mulish_900Black = {fontFamily: 'IranSans-Black'};

export const fonts = {
  Mulish_400Regular: {...Mulish_400Regular},
  Mulish_500Medium: {...Mulish_500Medium},
  Mulish_600SemiBold: {...Mulish_600SemiBold},
  Mulish_700Bold: {...Mulish_700Bold},
  Mulish_800ExtraBold: {...Mulish_800ExtraBold},
  Mulish_900Black: {...Mulish_900Black},
};

// $Mulish-Regular: 'Mulish-Regular';
// $Mulish-SemiBold: 'Mulish-SemiBold';
// $Mulish-Bold: 'Mulish-Bold';
// $Mulish-ExtraBold: 'Mulish-ExtraBold';
// $Mulish-Black: 'Mulish-Black';
